import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async (portalModule, params) => {
  return await dponetAPI.get(
    `/company_guest_portal_configs/${portalModule}/company_guest_emails`,
    { params },
  )
}

const create = async (portalModule, data) => {
  return await dponetAPI.post(
    `/company_guest_portal_configs/${portalModule}/company_guest_emails`,
    { companyGuestEmail: data },
  )
}

const destroy = async (portalModule, companyGuestEmailId) => {
  return await dponetAPI.delete(
    `/company_guest_portal_configs/${portalModule}/company_guest_emails/${companyGuestEmailId}`,
  )
}

export default { get, create, destroy }
